import _classCallCheck from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/noser/hris/uat1/noserhrisweb/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/ui/button.js)
 * Version: 21.1.12
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../core/renderer";
import devices from "../core/devices";
import { render } from "./widget/utils.ink_ripple";
import registerComponent from "../core/component_registrator";
import { isMaterial, current } from "./themes";
import Action from "../core/action";
import ValidationEngine from "./validation_engine";
import Widget from "./widget/ui.widget";
import { active as activeEvents, click as clickEvent, dxClick as dxClickEvent } from "../events/short";
import { extend } from "../core/utils/extend";
import { FunctionTemplate } from "../core/templates/function_template";
import { getImageContainer, getImageSourceType } from "../core/utils/icon";
import { getPublicElement } from "../core/element";
var ANONYMOUS_TEMPLATE_NAME = "content";

var Button =
/*#__PURE__*/
function (_Widget) {
  _inherits(Button, _Widget);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
    _this._feedbackHideTimeout = 100;
    return _this;
  }

  _createClass(Button, [{
    key: "_$content",
    value: function _$content() {
      return this.$element().find(".dx-button-content");
    }
  }, {
    key: "_$submitInput",
    value: function _$submitInput() {
      return this.$element().find(".dx-button-submit-input");
    }
  }, {
    key: "_attachActiveEvents",
    value: function _attachActiveEvents(active, inactive) {
      var $el = this._eventBindingTarget();

      var selector = this._activeStateUnit;
      activeEvents.off($el, {
        namespace: "inkRipple",
        selector: selector
      });
      activeEvents.on($el, new Action(active), new Action(inactive, {
        excludeValidators: ["disabled", "readOnly"]
      }), {
        showTimeout: this._feedbackShowTimeout,
        hideTimeout: this._feedbackHideTimeout,
        selector: selector,
        namespace: "inkRipple"
      });
    }
  }, {
    key: "_defaultOptionsRules",
    value: function _defaultOptionsRules() {
      return _get(_getPrototypeOf(Button.prototype), "_defaultOptionsRules", this).call(this).concat([{
        device: function device() {
          return "desktop" === devices.real().deviceType && !devices.isSimulator();
        },
        options: {
          focusStateEnabled: true
        }
      }, {
        device: function device() {
          return isMaterial(current());
        },
        options: {
          useInkRipple: true
        }
      }]);
    }
  }, {
    key: "_executeClickAction",
    value: function _executeClickAction(event) {
      this._clickAction({
        validationGroup: this._validationGroupConfig,
        event: event
      });
    }
  }, {
    key: "_findGroup",
    value: function _findGroup() {
      var $element = this.$element();

      var model = this._modelByElement($element);

      var _this$option = this.option(),
          validationGroup = _this$option.validationGroup;

      return validationGroup || ValidationEngine.findGroup($element, model);
    }
  }, {
    key: "_getContentData",
    value: function _getContentData() {
      var _this$option2 = this.option(),
          icon = _this$option2.icon,
          text = _this$option2.text,
          type = _this$option2.type,
          _templateData = _this$option2._templateData;

      return extend({
        icon: "back" === type && !icon ? "back" : icon,
        text: text
      }, _templateData);
    }
  }, {
    key: "_getDefaultOptions",
    value: function _getDefaultOptions() {
      return extend(_get(_getPrototypeOf(Button.prototype), "_getDefaultOptions", this).call(this), {
        hoverStateEnabled: true,
        onClick: null,
        type: "normal",
        text: "",
        icon: "",
        iconPosition: "left",
        validationGroup: void 0,
        activeStateEnabled: true,
        template: "content",
        useSubmitBehavior: false,
        useInkRipple: false,
        _templateData: {},
        stylingMode: "contained"
      });
    }
  }, {
    key: "_getSubmitAction",
    value: function _getSubmitAction() {
      var _this2 = this;

      var needValidate = true;
      var validationStatus = "valid";
      return this._createAction(function (_ref) {
        var event = _ref.event;

        if (needValidate) {
          var validationGroup = _this2._validationGroupConfig;

          if (validationGroup) {
            var _validationGroup$vali = validationGroup.validate(),
                status = _validationGroup$vali.status,
                complete = _validationGroup$vali.complete;

            validationStatus = status;

            if ("pending" === status) {
              needValidate = false;

              _this2.option("disabled", true);

              complete.then(function (_ref2) {
                var status = _ref2.status;

                _this2.option("disabled", false);

                validationStatus = status;
                "valid" === validationStatus && _this2._submitInput().click();
                needValidate = true;
              });
            }
          }
        }

        "valid" !== validationStatus && event.preventDefault();
        event.stopPropagation();
      });
    }
  }, {
    key: "_initMarkup",
    value: function _initMarkup() {
      this.$element().addClass("dx-button");

      this._renderType();

      this._renderStylingMode();

      this._renderInkRipple();

      this._renderClick();

      this._updateAriaLabel();

      _get(_getPrototypeOf(Button.prototype), "_initMarkup", this).call(this);

      this._updateContent();

      this.setAria("role", "button");
    }
  }, {
    key: "_getAnonymousTemplateName",
    value: function _getAnonymousTemplateName() {
      return ANONYMOUS_TEMPLATE_NAME;
    }
  }, {
    key: "_initTemplates",
    value: function _initTemplates() {
      var _this3 = this;

      this._templateManager.addDefaultTemplates({
        content: new FunctionTemplate(function (_ref3) {
          var _ref3$model = _ref3.model,
              model = _ref3$model === void 0 ? {} : _ref3$model,
              container = _ref3.container;
          var text = model.text,
              icon = model.icon;

          var _this3$option = _this3.option(),
              iconPosition = _this3$option.iconPosition;

          var $icon = getImageContainer(icon);
          var $textContainer = text && $("<span>").text(text).addClass("dx-button-text");
          var $container = $(container);
          $container.append($textContainer);

          if ("left" === iconPosition) {
            $container.prepend($icon);
          } else {
            $icon.addClass("dx-icon-right");
            $container.append($icon);
          }
        })
      });

      _get(_getPrototypeOf(Button.prototype), "_initTemplates", this).call(this);
    }
  }, {
    key: "_optionChanged",
    value: function _optionChanged(args) {
      var name = args.name;

      switch (name) {
        case "onClick":
          this._updateClick();

          break;

        case "icon":
        case "text":
          this._updateContent();

          this._updateAriaLabel();

          break;

        case "type":
          this._updateType();

          this._updateContent();

          break;

        case "_templateData":
          break;

        case "template":
        case "iconPosition":
          this._updateContent();

          break;

        case "stylingMode":
          this._updateStylingMode();

          break;

        case "useSubmitBehavior":
          this._updateSubmitInput();

          break;

        case "useInkRipple":
          this._invalidate();

          break;

        default:
          _get(_getPrototypeOf(Button.prototype), "_optionChanged", this).call(this, args);

      }
    }
  }, {
    key: "_renderClick",
    value: function _renderClick() {
      var _this4 = this;

      var $el = this.$element();
      dxClickEvent.off($el, {
        namespace: this.NAME
      });
      dxClickEvent.on($el, function (event) {
        return _this4._executeClickAction(event);
      }, {
        namespace: this.NAME
      });

      this._updateClick();
    }
  }, {
    key: "_renderInkRipple",
    value: function _renderInkRipple() {
      var _this5 = this;

      var _this$option3 = this.option(),
          text = _this$option3.text,
          icon = _this$option3.icon,
          type = _this$option3.type,
          useInkRipple = _this$option3.useInkRipple;

      if (useInkRipple) {
        var isOnlyIconButton = !text && icon || "back" === type;

        var _inkRipple = render(isOnlyIconButton ? {
          waveSizeCoefficient: 1,
          useHoldAnimation: false,
          isCentered: true
        } : {});

        var changeWaveVisibility = function changeWaveVisibility(event, visible) {
          var _this5$option = _this5.option(),
              activeStateEnabled = _this5$option.activeStateEnabled,
              useInkRipple = _this5$option.useInkRipple;

          if (useInkRipple && activeStateEnabled && !_this5._disposed) {
            var config = {
              element: _this5._$content(),
              event: event
            };
            visible ? _inkRipple.showWave(config) : _inkRipple.hideWave(config);
          }
        };

        this._attachActiveEvents(function (_ref4) {
          var event = _ref4.event;
          return changeWaveVisibility(event, true);
        }, function (_ref5) {
          var event = _ref5.event;
          return changeWaveVisibility(event);
        });
      }
    }
  }, {
    key: "_renderStylingMode",
    value: function _renderStylingMode() {
      var $element = this.$element();

      var _this$option4 = this.option(),
          stylingMode = _this$option4.stylingMode;

      if (-1 === ["contained", "text", "outlined"].indexOf(stylingMode)) {
        stylingMode = this._getDefaultOptions().stylingMode;
      }

      $element.addClass("dx-button-mode-".concat(stylingMode));
    }
  }, {
    key: "_renderSubmitInput",
    value: function _renderSubmitInput() {
      var _this$option5 = this.option(),
          useSubmitBehavior = _this$option5.useSubmitBehavior;

      if (useSubmitBehavior) {
        var submitAction = this._getSubmitAction();

        var $content = this._$content();

        $("<input>").attr("type", "submit").attr("tabindex", -1).addClass("dx-button-submit-input").appendTo($content);
        clickEvent.on(this._$submitInput(), function (event) {
          return submitAction({
            event: event
          });
        });
      }
    }
  }, {
    key: "_renderType",
    value: function _renderType() {
      var _this$option6 = this.option(),
          type = _this$option6.type;

      var $element = this.$element();
      type && $element.addClass("dx-button-".concat(type));
    }
  }, {
    key: "_submitInput",
    value: function _submitInput() {
      return this._$submitInput().get(0);
    }
  }, {
    key: "_supportedKeys",
    value: function _supportedKeys() {
      var _this6 = this;

      var click = function click(e) {
        e.preventDefault();

        _this6._executeClickAction(e);
      };

      return extend(_get(_getPrototypeOf(Button.prototype), "_supportedKeys", this).call(this), {
        space: click,
        enter: click
      });
    }
  }, {
    key: "_updateAriaLabel",
    value: function _updateAriaLabel() {
      var ariaTarget = this._getAriaTarget();

      var _this$option7 = this.option(),
          icon = _this$option7.icon,
          text = _this$option7.text;

      if (!text) {
        if ("image" === getImageSourceType(icon)) {
          icon = -1 === icon.indexOf("base64") ? icon.replace(/.+\/([^.]+)\..+$/, "$1") : "Base64";
        }

        text = icon || "";
      }

      ariaTarget.attr("aria-label", text || null);
    }
  }, {
    key: "_updateClick",
    value: function _updateClick() {
      var _this7 = this;

      this._clickAction = this._createActionByOption("onClick", {
        excludeValidators: ["readOnly"],
        afterExecute: function afterExecute() {
          var _this7$option = _this7.option(),
              useSubmitBehavior = _this7$option.useSubmitBehavior;

          useSubmitBehavior && setTimeout(function () {
            return _this7._submitInput().click();
          });
        }
      });
    }
  }, {
    key: "_updateContent",
    value: function _updateContent() {
      var $element = this.$element();

      var $content = this._$content();

      var data = this._getContentData();

      var _this$option8 = this.option(),
          template = _this$option8.template,
          iconPosition = _this$option8.iconPosition;

      var icon = data.icon,
          text = data.text;
      $content.length ? $content.empty() : $content = $("<div>").addClass("dx-button-content").appendTo($element);
      $element.toggleClass("dx-button-has-icon", !!icon).toggleClass("dx-button-icon-right", !!icon && "left" !== iconPosition).toggleClass("dx-button-has-text", !!text);
      var $template = $(this._getTemplateByOption("template").render({
        model: data,
        container: getPublicElement($content),
        transclude: this._templateManager.anonymousTemplateName === template
      }));

      if ($template.hasClass("dx-template-wrapper")) {
        $template.addClass("dx-button-content");
        $content.replaceWith($template);
      }

      this._updateSubmitInput();
    }
  }, {
    key: "_updateSubmitInput",
    value: function _updateSubmitInput() {
      var _this$option9 = this.option(),
          useSubmitBehavior = _this$option9.useSubmitBehavior;

      var $submitInput = this._$submitInput();

      if (!useSubmitBehavior && $submitInput.length) {
        $submitInput.remove();
      } else if (useSubmitBehavior && !$submitInput.length) {
        this._renderSubmitInput();
      }
    }
  }, {
    key: "_updateStylingMode",
    value: function _updateStylingMode() {
      var $element = this.$element();
      ["contained", "text", "outlined"].map(function (mode) {
        return "dx-button-mode-".concat(mode);
      }).forEach(function (className) {
        $element.removeClass(className);
      });

      this._renderStylingMode();
    }
  }, {
    key: "_updateType",
    value: function _updateType() {
      var $element = this.$element();
      ["back", "danger", "default", "normal", "success"].map(function (type) {
        return "dx-button-".concat(type);
      }).forEach(function (className) {
        $element.removeClass(className);
      });

      this._renderType();
    }
  }, {
    key: "_validationGroupConfig",
    get: function get() {
      return ValidationEngine.getGroupConfig(this._findGroup());
    }
  }]);

  return Button;
}(Widget);

registerComponent("dxButton", Button);
export default Button;